export enum ReportManagerialAccountingTab {
  VDP = 'vdp',
  VDD = 'vdd',
  VDP_VDD_COMPOSITE = 'vdp-vdd',
  FUNCTIONALITY = 'functionality',
  ROLE_TYPE = 'role-type',
  ALLOCATION_KEY = 'allocation-key',
}
